<template>
  <data-table
    :headers="headers"
    :data="items"
    :loading="isLoading"
    :hide-delete="true"
    :hide-edit="true"
    :hide-table-bottom="true"
  />
</template>

<script>
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import AnalysisTableRequest from 'Modules/contacard/analysisTable/AnalysisTableRequest';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import DataTable from '@/app/arch/components/data-table/DataTable.vue';
import AnalysisLinkedObservationTypeColumnVue from 'Modules/contacard/analysisTable/components/columns/AnalysisLinkedObservationTypeColumn.vue';

export default {
  name: 'AnalysisTableCommentsList',
  components: { DataTable },
  mixins: [ServiceMixin],
  data: () => ({
    headers: [
      {
        text: 'Observação',
        value: 'message',
        options: {
          noWrap: false,
        },
      },
      {
        text: 'Vínculo',
        value: 'linked',
        component: AnalysisLinkedObservationTypeColumnVue,
      },
      {
        text: 'Criado por',
        value: 'createdBy',
      },
      {
        text: 'Data de criação',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
    ],
    requestClass: AnalysisTableRequest,
    loading: false,
    items: [],
    config: {
      errorMessage: 'Falha ao buscar listagem de observações!',
      showSuccessSwal: false,
    },
  }),
  computed: {
    getId() {
      return this.analysisTable.payload.registerClientId;
    },
    infoLoading() {
      return this.analysisTable.clientInfo.loading;
    },
    isLoading() {
      return this.infoLoading || this.loading;
    },
  },
  watch: {
    getId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.getData();
        }
      },
    },
  },
  methods: {
    getData() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.requestClass.listObs(
          this.makeDefaultParams({
            Type: 'System',
          }),
        ),
        this.config,
        this.setDataItems,
      );
    },
    setDataItems(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.items = this.prepareData(
          response,
        );
      }
    },
    makeDefaultParams(params = {}) {
      return {
        RegisterClientId: this.getId,
        ...params,
      };
    },
  },
  inject: {
    analysisTable: {
      default() {
        return {
          payload: {
            registerClientId: '',
          },
          clientInfo: {
            loading: '',
          },
        };
      },
    },
  },
};
</script>
